export default __webpack_public_path__ + "static/google-play-badge-en-5353751dc6066038a3f06588b40098d7.png";